const handleDeleteDocumentModalDocCompany = {
  confirm: 'Do you really want to delete this entry?',
  title: 'DELETE DOCUMENT'
};

export default handleDeleteDocumentModalDocCompany;
